<template>
  <v-container
    class="pa-0 context-duration"
  >
    <template
      v-if="shipment != null && hasSchedule"
    >
      <v-row
        no-gutters
        class="mb-1"
      >
        <v-col cols="1">
          <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon
                v-on="on"
                :class="['wrld_black--text']"
                color="#777777"
                class="custom-class"
                :size="$vuetify.breakpoint.xlOnly ? 17 : 15"
                >
                  far fa-clock
                </v-icon>
              </template>
              <span>{{$t('shipments.shipment_duration')}}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="11" class="drop-text">
            <span
              class="wrld_black--text"
            >
              {{ shipment.schedule.metrics.totalDuration | durationToHoursMinutes }}
            </span>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="mb-1"
      >
        <v-col cols="1">
          <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon  v-on="on"
                :class="['wrld_black--text']"
                color="#777777"
                class="custom-class"
                :size="$vuetify.breakpoint.xlOnly ? 17 : 15"
                >
                  far fa-compass
                </v-icon>
              </template>
              <span>{{$t('shipments.shipment_distance')}}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="11" class="drop-text">
            <span
              class="wrld_black--text"
            >
              {{ shipment.schedule.metrics.totalDistance | filterDistance }}
            </span>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
  export default {
    name: 'ShipmentsGroupByDayContextDuration',
    props: {
      shipment: { type: Object,  default: null }
    },
    computed: {
      hasSchedule () {
        switch (this.shipment.type) {
          case 'OnePL':
          case 'TwoPL':
            return true
          default:
            return false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .context-duration {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 13px;
    margin-top: 40px;
  }
</style>
